export async function getClipboardItemsFromPasteEvent(e) {
    const items = Array.from(e.clipboardData?.items || []);
    return items.map(item => ({
        type: item.type,
        getBlob: async () => {
            const file = item.getAsFile();
            return file ?? null;
        },
        getText: () => new Promise((resolve) => {
            item.getAsString(str => resolve(str ?? null));
        }),
    }));
}
export async function getClipboardItemsFromNavigator() {
    const clipboardItems = await navigator.clipboard.read();
    return clipboardItems.flatMap(item => item.types.map(type => ({
        type,
        getBlob: async () => {
            try {
                const blob = await item.getType(type);
                return blob ?? null;
            }
            catch {
                return null;
            }
        },
        getText: async () => {
            try {
                const blob = await item.getType(type);
                const text = await blob.text();
                return text ?? null;
            }
            catch {
                return null;
            }
        },
    })));
}
